module.exports = __webpack_public_path__ + "img/map_pc_3.7b52b8f7.png";